import { NotificationManager } from '@sravni/react-design-system/lib/Notifications';
import { IClientError } from '@sravni/ugc/lib/client';
import { dispatchErrorToast, IDispatchErrorToastParams } from '@sravni/ugc/lib/utils/dispatchErrorToast';

type Params = Parameters<IDispatchErrorToastParams['callback']>[0];

export const errorCallback = (error: IClientError) => {
  const handleToastCallback = (params: Params) => {
    // @ts-ignore
    NotificationManager.show(params.title, null, params.description);
  };
  dispatchErrorToast({ code: error?.response?.status, id: error.id, callback: handleToastCallback });
};
